import React from 'react';

const checkUrl = () => {
    let url = window.location.href;
    if (url.match(/detalhes/)){
       return '-details';
    } else {
        return '';
    }
};

const FinanceLink = ({ orderCode, disableInvoiceLink }) => (
    <span className="finance-links">
        <a
            target="_blank"
            href={`/cliente/minhas-viagens/transacao/emitreceipt/${orderCode}`}
            data-action={`my-trips-generate-receipt${checkUrl()}`}
        >
            Gerar Recibo
        </a>
        <span className="divider" />
        <a
            target="_blank"
            href={`/cliente/minhas-viagens/transacao/emitinvoice/${orderCode}`}
            data-action={`my-trips-invoice${checkUrl()}`}
        >
            Visualizar nota fiscal
        </a>
    </span>
);

export default FinanceLink;